import { styled } from 'styled-components'

export const Root = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  position: absolute;
  top: -40px;
  right: -40px;
  cursor: pointer;
`
